export enum BulkCompanyChangeAddressStepsEnum {
  FormDescription = 0,
  NewAddress = 1,
  Summary = 2
}
